import axios from "axios";

export const useFetchCurrency = async () =>
{
    try {
        const now = new Date().getTime();
        if(localStorage.getItem('currencyData') !== null){
        const cachedData = localStorage.getItem('currencyData');
        
        if (cachedData) {
          const { rates, timestamp } = JSON.parse(cachedData);
          if (now - timestamp < 24 * 60 * 60 * 1000) {
            return rates;
          }
        }
    }
    
        const data = await axios.get("https://api.frankfurter.dev/v1/latest?base=usd");
        
        localStorage.setItem('currencyData', JSON.stringify({
           rates : data.data.rates,
          timestamp: now
        }));
    
        return data.data.rates;
      } catch (error) {
        console.error('Currency service error:', error);
        throw error;
      }
    
}